import { useState } from 'react';

const TONES = {
  neutral: 'text-gray-500 hover:bg-gray-100 hover:text-gray-700',
  primary: 'text-primary hover:bg-red-50',
  danger: 'text-red-600 hover:bg-red-50',
};

// Icon-only action button with an instant tooltip. `as` lets it render a router Link; `label` is the
// tooltip + aria-label. The tooltip is position:fixed so the table's overflow can't clip it.
export default function IconButton({ as: Component = 'button', label, tone = 'neutral', className = '', children, ...props }) {
  const [tip, setTip] = useState(null);

  const show = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    setTip({ x: r.left + r.width / 2, y: r.top });
  };
  const hide = () => setTip(null);

  return (
    <>
      <Component
        {...(Component === 'button' ? { type: 'button' } : {})}
        aria-label={label}
        onMouseEnter={show}
        onMouseLeave={hide}
        onFocus={show}
        onBlur={hide}
        className={`inline-flex h-8 w-8 items-center justify-center rounded-md transition-colors
          focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary ${TONES[tone]} ${className}`}
        {...props}
      >
        {children}
      </Component>
      {tip && (
        <span
          role="tooltip"
          style={{ left: tip.x, top: tip.y - 6 }}
          className="pointer-events-none fixed z-50 -translate-x-1/2 -translate-y-full whitespace-nowrap rounded bg-gray-900 px-2 py-1 text-xs font-medium text-white shadow"
        >
          {label}
        </span>
      )}
    </>
  );
}
